import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../navigation/Header";
import Footer from "../navigation/Footer";

export default function MainLayout() {
  const location = useLocation();

  // Scroll to top on route change to ensure new pages start from the top —
  // except when the URL names a section. A link to /privacy#cookies is asking
  // for that section, and the page resolving it scrolls there itself; this
  // effect runs after the child's (parents update last), so without the guard
  // it would land the reader back at the top every time.
  useEffect(() => {
    if (location.hash) return;
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen flex flex-col font-sans">
      <Header />
      <main className="flex-1 flex flex-col">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}